import { render, staticRenderFns } from "./TeoricasAguardandoProcessamentoModal.vue?vue&type=template&id=6b6197ad&scoped=true"
import script from "./TeoricasAguardandoProcessamentoModal.vue?vue&type=script&lang=js"
export * from "./TeoricasAguardandoProcessamentoModal.vue?vue&type=script&lang=js"
import style0 from "./TeoricasAguardandoProcessamentoModal.vue?vue&type=style&index=0&id=6b6197ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6197ad",
  null
  
)

export default component.exports